<template>
  <div class="w-full">
    <button
      @click="goBack"
      class="text-xs md:text-sm flex items-center gap-2 border border-border-color hover:border-gray-2 py-2 px-4 rounded-lg"
    >
      <arrow-left-icon />
      Back
    </button>

    <h2 class="py-4 text-xl md:text-2xl font-bold" test-id="title">
      {{ isBusinessTypeHNI ? 'Basic' : 'Business' }} Information
    </h2>

    <div class="pt-4 pb-8 flex flex-col gap-6">
      <div
        class="kyc-stage border border-border-10 hover:border-gray-2 rounded-2xl p-5 md:p-6 bg-white"
        :class="item.show ? 'open-step' : 'close-step'"
        v-for="item in isBusinessTypeHNI ? hniInfo : businessInfo"
        :key="item.step"
      >
        <div
          class="flex justify-between items-center cursor-pointer"
          @click="item.show = !item.show"
        >
          <div class="flex gap-5 items-center">
            <span>
              <completed-icon
                v-if="isStageApproved(item.step)"
                size="h-8 w-8"
              />
              <disputed-icon v-else-if="isStageDisputed(item.step)" />
              <pending-icon v-else />
            </span>
            <p class="text-black-10 font-bold">{{ item.title }}</p>
          </div>
          <arrow-down-icon
            class="transform transition duration-300"
            :class="item.show ? 'rotate-180' : 'rotate-0'"
            color="#5D5E68"
            size="h-6 w-6"
          />
        </div>

        <component :is="item.component" :business="item" />
      </div>

      <p
        class="text self-center my-2 text-xs md:text-sm text-center text-gray-muted"
      >
        All information confirmed. Click "Complete" to submit this section.
      </p>

      <button
        :disabled="!isComplete"
        class="submitBtn self-center w-44 h-12 md:w-52 md:h-14 rounded-lg"
        @click="goBack"
      >
        Complete
      </button>
    </div>
  </div>
</template>

<script>
import { BUSINESS_INFO, HNI_BUSINESS_INFO } from '@/utils/constants'
import kyc from '@/mixins/kyc.js'
import { gsap } from 'gsap'

export default {
  name: 'BusinessInformation',
  mixins: [kyc],
  data () {
    return {
      activeStage: [],
      businessInfo: BUSINESS_INFO,
      hniInfo: HNI_BUSINESS_INFO
    }
  },
  components: {
    ArrowLeftIcon: () => import('@/assets/v2/icons/ArrowIcon.vue'),
    ArrowDownIcon: () => import('@/assets/v2/icons/ArrowDownTwo.vue'),
    PendingIcon: () => import('@/assets/v2/icons/PendingIconTwo.vue'),
    CompletedIcon: () => import('@/assets/v2/icons/CheckMarkIcon.vue'),
    DisputedIcon: () => import('@/assets/v2/icons/AlertCircle.vue'),
    BusinessProfile: () =>
      import('@/components/v2/completeKycForm/business/BusinessProfile.vue'),
    UserProfile: () =>
      import('@/components/v2/completeKycForm/business/UserProfile.vue'),
    UserAddress: () =>
      import('@/components/v2/completeKycForm/business/UserAddress.vue'),
    TransactionProfile: () =>
      import('@/components/v2/completeKycForm/business/TransactionProfile.vue'),
    EntityAddress: () =>
      import('@/components/v2/completeKycForm/business/EntityAddress.vue'),
    ContactInformation: () =>
      import('@/components/v2/completeKycForm/business/ContactInformation.vue')
  },
  computed: {
    isComplete () {
      const infoArray = this.isBusinessTypeHNI
        ? this.hniInfo
        : this.businessInfo
      const allSteps = infoArray.map((item) => item.step)

      return allSteps.every((item) => this.submittedStages.includes(item))
    }
  },
  methods: {
    goBack () {
      this.$router.go(-1)
    },
    isStageApproved (step) {
      return this.submittedStages.includes(step)
    },
    isStageDisputed (step) {
      return this.disputedStages.includes(step)
    }
  },
  mounted () {
    gsap.context(() => {
      gsap.fromTo(
        '.kyc-stage',
        {
          y: 150,
          opacity: 0
        },
        {
          y: 0,
          stagger: 0.2,
          opacity: 1
        }
      )
      gsap.fromTo(
        '.text, .submitBtn',
        {
          y: 150,
          opacity: 0
        },
        {
          y: 0,
          delay: this.isBusinessTypeHNI ? 0.5 : 0.8,
          opacity: 1
        }
      )
    })
  },
  unmounted () {
    gsap.revert()
  }
}
</script>

<style scoped>
.submitBtn {
  background-color: var(--color-primary);
  color: white;
}

.submitBtn:disabled {
  background-color: #e0e0e0;
  color: #757575;
}
</style>
